export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const SELECT_PERFECT_LIFE_PLAN = 'SELECT_PERFECT_LIFE_PLAN'

export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})

export const selectPerfectLifePlan = (planCode) => ({
  type: SELECT_PERFECT_LIFE_PLAN,
  payload: planCode,
})
